module.exports = __webpack_public_path__ + "img/ansible.1df7e5bc.svg";